import React, { useState, useEffect, useRef, createRef } from "react";
import * as qs from "query-string";
import { connect } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import history from "@safecv/shared/history";
import {
  fetchVerificationDetailsByJobId,
  fetchAdditionalDocuments,
  getCommentLetter,
  clearCommentLetter,
} from "@safecv/actions/postActions";
import { handleURLChange, handleURLUpdate } from "@safecv/shared/urlParams";
import { override } from "@safecv/shared/sharedFunction";
import PlanViewer from "./PlanViewer";
import Footer from "../Core/AppFooter";
import PlanError from "../Planinfo/PlanError";
import Header from "./HeaderComponent/Header";
import AnnotationSidebar from "./AnnotationSidebar";
import ReconciliationSidebarLanding from "./ReconciliationComponent/ReconciliationSidebarLanding";
import ProcessingScreen from "./ProcessingScreen";
import "./VerificationLanding.css";
import _ from "lodash";

const processingStatus = [
  "processing",
  "submitted",
  "verifying",
  "submitted_for_verification",
];

function VerificationLanding(props) {
  const urlSearch = qs.parse(window.location.search);
  const viewTypeFromUrl = urlSearch.viewType;
  const sidebarRef = useRef(null);
  const {
    match: {
      params: { viewerType, jobId },
    },
    xfdfLoader,
    queryparams,
    getCommentLetter,
    commentLetterId,
    annotationPayload,
    spinnerLoading,
  } = props;

  const [isSupportDocSelected, setSupportdocSelection] = useState(
    window.location.pathname.split("/").includes("supportingDocs")
  );
  const [loading, setLoading] = useState(false);
  const [planDetails, setPlanDetails] = useState(null);
  const [viewType, setViewType] = useState(viewTypeFromUrl);
  const [selectedAnnotationUuid, setSelectedAnnotationUuid] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isSearchEnable, setIsSearchEnable] = useState(
    viewTypeFromUrl &&
      (viewTypeFromUrl === "basicPdfSearch" ||
        viewTypeFromUrl === "enhancedSearch")
      ? true
      : false
  );
  const [selectedAnnotation, setSelectedAnnotation] = useState(null);
  const [restoredAnnotationId, setRestoredAnnotationId] = useState(null);
  const [selectedStampDocument, setSelectedStampDocument] = useState(null);
  const [selectedReconciliation, setSelectedReconciliation] = useState(null);
  const [
    isReconciliationSidebarOpen,
    setIsReconciliationSidebarOpen,
  ] = useState(false);
  const [selectedEnhancedSearch, setSelectedEnhancedSearch] = useState(null);
  const [
    selectedGroupEnhancedSearch,
    setSelectedGroupEnhancedSearch,
  ] = useState(null);
  const [isPdfSelected, setIsPdfSelected] = useState(
    ["pdfviewer", "combinedview"].includes(viewerType)
  );
  const [isDocumentSelected, setIsdocumentSelected] = useState(
    viewerType !== "pdfviewer"
  );
  const [isCommentRepoSelected, setIsCommentRepoSelected] = useState(
    viewerType === "combinedcommentletter"
  );
  const [selectedSearchResult, setSelectedSearchResult] = useState(null);
  const [annotationRefs, setAnnotationRefs] = useState({});
  const [
    selectedCompliancesCheckboxValue,
    setSelectedCompliancesCheckboxValue,
  ] = useState(
    viewTypeFromUrl &&
      (viewTypeFromUrl.includes("compliance") ||
        viewTypeFromUrl.includes("violation"))
      ? viewTypeFromUrl.split(",")
      : ["compliance", "violation"]
  );

  const [currentDocVal, setCurrentDocVal] = useState("");

  useEffect(() => {
    const annotationData = annotationPayload.filter(
      (annotation) => !annotation.discarded
    );

    annotationData.map(
      (annotation) =>
        (annotationRefs[annotation.annotationName] =
          annotationRefs[annotation.annotationName] || createRef())
    );

    setAnnotationRefs(annotationRefs);
  }, [annotationPayload]);

  useEffect(() => {
    if (
      planDetails &&
      (planDetails.planType.toLowerCase() === "commercial" ||
        !planDetails.algoEnabled)
    ) {
      setViewType("annotated");
    } else if (!viewType && planDetails && planDetails.preference) {
      let viewtype =
        planDetails.preference.output === "annotation"
          ? "annotated"
          : planDetails.preference.output;
      setViewType(viewtype);
    }
  }, [planDetails]);

  useEffect(() => {
    setLoading(true);

    props.fetchAdditionalDocuments(jobId);
    fetchVerificationDetailsByJobId(jobId).then((res) => {
      setPlanDetails(res);
      setLoading(false);
    });
    getCommentLetter(jobId);
  }, []);

  useEffect(() => {
    isDocumentSelected && setIsSidebarOpen(false);
    !isDocumentSelected && setIsCommentRepoSelected(false);
  }, [isDocumentSelected]);

  useEffect(() => {
    let type;
    //First check to see if supporting doc route has been triggered
    if (isSupportDocSelected) {
      type = "supportingDocs";
      setIsSidebarOpen(false);
      setIsReconciliationSidebarOpen(false);
      setIsPdfSelected(false);
      setIsdocumentSelected(false);
    } else {
      // Remove id query param if not in support doc view
      if (_.has(urlSearch, "id")) {
        delete urlSearch["id"];
        history.replace({
          search: qs.stringify(urlSearch),
        });
      }
      type = "pdfviewer";
      setIsSidebarOpen(true);
      if (isPdfSelected && isDocumentSelected) {
        type = "combinedview";
        setIsCommentRepoSelected(false);
        setIsSidebarOpen(false);
        setIsReconciliationSidebarOpen(false);
        setIsPdfSelected(true);
      } else if (
        !isPdfSelected &&
        isDocumentSelected &&
        !isCommentRepoSelected
      ) {
        type = "commentletter";
        setIsSidebarOpen(false);
        setIsReconciliationSidebarOpen(false);
      } else if (
        !isPdfSelected &&
        isDocumentSelected &&
        isCommentRepoSelected
      ) {
        type = "combinedcommentletter";
        setIsSidebarOpen(false);
        setIsReconciliationSidebarOpen(false);
      } else if (
        !isDocumentSelected &&
        !isCommentRepoSelected &&
        !isPdfSelected
      ) {
        setIsPdfSelected(true);
        setIsSidebarOpen(true);
      }
      handleURLUpdate(jobId, type);
    }
  }, [
    isPdfSelected,
    isDocumentSelected,
    isCommentRepoSelected,
    isSupportDocSelected,
  ]);

  useEffect(() => {
    handleURLChange({ viewType });
  }, [viewType]);

  useEffect(() => {
    return () => {
      props.clearCommentLetter();
    };
  }, []);

  return (
    <div>
      {planDetails ? (
        <>
          <Header
            isSidebarOpen={isSidebarOpen}
            setIsSidebarOpen={setIsSidebarOpen}
            planName={planDetails.planName}
            algoEnabled={planDetails.algoEnabled}
            isPdfSelected={isPdfSelected}
            setIsPdfSelected={setIsPdfSelected}
            isDocumentSelected={isDocumentSelected}
            setIsdocumentSelected={setIsdocumentSelected}
            jobId={jobId}
            planStatus={planDetails.status}
            planDetails={planDetails}
            setSelectedStampDocument={setSelectedStampDocument}
            setIsReconciliationSidebarOpen={setIsReconciliationSidebarOpen}
            setViewType={setViewType}
            isSupportDocSelected={isSupportDocSelected}
            setSupportdocSelection={setSupportdocSelection}
            setCurrentDocVal={setCurrentDocVal}
            setIsCommentRepoSelected={setIsCommentRepoSelected}
          />
          {planDetails.status.toLowerCase() === "error" &&
          !isSupportDocSelected ? (
            <PlanError
              reasonForFailure={planDetails.reasonForFailure}
              description={planDetails.description}
            />
          ) : (
            <div
              className={`landing-body-container ${
                xfdfLoader ? "full-screen-loader" : ""
              }`}
            >
              {!isReconciliationSidebarOpen ? (
                <AnnotationSidebar
                  jobId={jobId}
                  viewType={viewType}
                  setViewType={setViewType}
                  isSidebarOpen={isSidebarOpen}
                  setIsSidebarOpen={setIsSidebarOpen}
                  setIsPdfSelected={setIsPdfSelected}
                  isDocumentSelected={isDocumentSelected}
                  setIsdocumentSelected={setIsdocumentSelected}
                  setSelectedAnnotation={setSelectedAnnotation}
                  setSelectedAnnotationUuid={setSelectedAnnotationUuid}
                  planStatus={planDetails.status}
                  isSearchEnable={isSearchEnable}
                  setIsSearchEnable={setIsSearchEnable}
                  selectedSearchResult={selectedSearchResult}
                  setSelectedSearchResult={setSelectedSearchResult}
                  selectedAnnotation={selectedAnnotation}
                  setRestoredAnnotationId={setRestoredAnnotationId}
                  isPlanProcessing={processingStatus.includes(
                    planDetails.status.toLowerCase()
                  )}
                  selectedEnhancedSearch={selectedEnhancedSearch}
                  setSelectedEnhancedSearch={setSelectedEnhancedSearch}
                  setSelectedGroupEnhancedSearch={
                    setSelectedGroupEnhancedSearch
                  }
                  sidebarRef={sidebarRef}
                  annotationRefs={annotationRefs}
                  selectedCompliancesCheckboxValue={
                    selectedCompliancesCheckboxValue
                  }
                  setSelectedCompliancesCheckboxValue={
                    setSelectedCompliancesCheckboxValue
                  }
                  isReconciliationSidebarOpen={isReconciliationSidebarOpen}
                  isPlanTypeCommercial={
                    planDetails.planType.toLowerCase() === "commercial"
                  }
                  setSupportdocSelection={setSupportdocSelection}
                  algoEnabled={planDetails.algoEnabled}
                />
              ) : (
                <ReconciliationSidebarLanding
                  jobId={jobId}
                  setSelectedReconciliation={setSelectedReconciliation}
                  setIsReconciliationSidebarOpen={
                    setIsReconciliationSidebarOpen
                  }
                />
              )}
              <PlanViewer
                jobId={jobId}
                viewType={viewType}
                isSidebarOpen={isSidebarOpen}
                isPdfSelected={isPdfSelected}
                isDocumentSelected={isDocumentSelected}
                isCommentRepoSelected={isCommentRepoSelected}
                pageNumber={urlSearch.pageNumber}
                selectedAnnotation={selectedAnnotation}
                selectedAnnotationUuid={selectedAnnotationUuid}
                isSearchEnable={isSearchEnable}
                selectedSearchResult={selectedSearchResult}
                planStatus={planDetails.status}
                restoredAnnotationId={restoredAnnotationId}
                setRestoredAnnotationId={setRestoredAnnotationId}
                selectedReconciliation={selectedReconciliation}
                isReconciliationSidebarOpen={isReconciliationSidebarOpen}
                selectedStampDocument={selectedStampDocument}
                setIsdocumentSelected={setIsdocumentSelected}
                setIsPdfSelected={setIsPdfSelected}
                sidebarRef={sidebarRef}
                annotationRefs={annotationRefs}
                setIsCommentRepoSelected={setIsCommentRepoSelected}
                isSupportDocSelected={isSupportDocSelected}
                setSupportdocSelection={setSupportdocSelection}
                selectedCompliancesCheckboxValue={
                  selectedCompliancesCheckboxValue
                }
                selectedEnhancedSearch={selectedEnhancedSearch}
                selectedGroupEnhancedSearch={selectedGroupEnhancedSearch}
                commentLetterId={commentLetterId}
                currentDocVal={currentDocVal}
                setViewType={setViewType}
                setSelectedStampDocument={setSelectedStampDocument}
              />
            </div>
          )}
          {processingStatus.includes(planDetails.status.toLowerCase()) && (
            <ProcessingScreen
              planDetails={planDetails}
              jobId={jobId}
              queryparams={queryparams}
            />
          )}
          <Footer />
        </>
      ) : (
        <FadeLoader
          css={override}
          height={15}
          width={5}
          radius={2}
          margin={2}
          color={"#4183C5"}
          loading={loading}
        />
      )}
      <FadeLoader
        css={override}
        height={15}
        width={5}
        radius={2}
        margin={2}
        color={"#4183C5"}
        loading={
          (xfdfLoader &&
            !processingStatus.includes(planDetails.status.toLowerCase())) ||
          spinnerLoading
        }
      />
    </div>
  );
}

const mapStatetoProps = (state) => ({
  xfdfLoader: state.landing.xfdfLoader,
  queryparams: state.plans.queryparams,
  commentLetterId: state.verification.id,
  annotationPayload: state.verification.annotationPayload,
  spinnerLoading: state.plans.spinnerLoading,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    fetchAdditionalDocuments: (data) => {
      dispatch(fetchAdditionalDocuments(data));
    },
    getCommentLetter: (jobId) => {
      dispatch(getCommentLetter(jobId));
    },
    clearCommentLetter: () => {
      dispatch(clearCommentLetter());
    },
  };
};

export default connect(
  mapStatetoProps,
  mapDispatchtoProps
)(VerificationLanding);
